var map = {
	"./Bank Trust/Metropolitan.png": "ccb4",
	"./Bank Trust/Prime Trust.png": "b4af",
	"./Bank Trust/Signature Bank.png": "3e29",
	"./Bank Trust/Silvergate.png": "0805",
	"./Blockchain DeFi/Dforce.png": "6275",
	"./Blockchain DeFi/DoraHacks.png": "e362",
	"./Blockchain DeFi/IOTEX.png": "7cee",
	"./Blockchain DeFi/Lendf.Me.png": "f496",
	"./Blockchain DeFi/Poolin.png": "9d2c",
	"./Blockchain DeFi/SWFT Coin.png": "7228",
	"./Blockchain DeFi/VeChain.png": "0a29",
	"./Brokers Institutions/B2C2.png": "5053",
	"./Brokers Institutions/Babel Finance.png": "a6fb",
	"./Brokers Institutions/Cumberland.png": "662a",
	"./Brokers Institutions/CyberX.png": "57b8",
	"./Brokers Institutions/FalconX.png": "3437",
	"./Brokers Institutions/Galaxy Digital.png": "5337",
	"./Brokers Institutions/LGO Markets.png": "6ca7",
	"./Brokers Institutions/OmniEx.png": "9daf",
	"./Brokers Institutions/Tagomi.png": "b615",
	"./Exchanges Wallets/Abra.png": "11dd",
	"./Exchanges Wallets/BingX.png": "ea32",
	"./Exchanges Wallets/BitMart.png": "5a42",
	"./Exchanges Wallets/Bitpush.png": "fe53",
	"./Exchanges Wallets/Bitrue.png": "00e9",
	"./Exchanges Wallets/Blocto.png": "88c1",
	"./Exchanges Wallets/Busha.png": "becd",
	"./Exchanges Wallets/ByBit.png": "b1cf",
	"./Exchanges Wallets/ByBit_bak.png": "470e",
	"./Exchanges Wallets/Cobo Wallet.png": "d3e6",
	"./Exchanges Wallets/CoinTiger.png": "188d",
	"./Exchanges Wallets/CoinW.png": "ef05",
	"./Exchanges Wallets/Deribit.png": "1790",
	"./Exchanges Wallets/Ellipal.png": "b1ac",
	"./Exchanges Wallets/Gate.png": "64fe",
	"./Exchanges Wallets/Huobi.png": "2abd",
	"./Exchanges Wallets/Kraken.png": "da00",
	"./Exchanges Wallets/Kucoin.png": "2154",
	"./Exchanges Wallets/LBANK.png": "f7e8",
	"./Exchanges Wallets/Mexo.png": "7a4e",
	"./Exchanges Wallets/OKEX.png": "1e49",
	"./Exchanges Wallets/OKX.png": "80af",
	"./Exchanges Wallets/Phemex.png": "f334",
	"./Exchanges Wallets/ProBit.png": "e0e8",
	"./Exchanges Wallets/Tbitex.png": "7fd8",
	"./Exchanges Wallets/TokenPocket.png": "fbaa",
	"./Exchanges Wallets/Valens Exchange.png": "6031",
	"./Exchanges Wallets/WBF.png": "4e52",
	"./Exchanges Wallets/XT.png": "e84d",
	"./Exchanges Wallets/Xbank.png": "677a",
	"./Exchanges Wallets/ZB.png": "d00a",
	"./Exchanges Wallets/Zoomex.png": "dfab",
	"./Stablecoins/HUSD.png": "ced8",
	"./Stablecoins/Paxos.png": "f83f",
	"./Stablecoins/USDC.png": "fff6",
	"./Stablecoins/USDK.png": "f3a7",
	"./Tech and Security/AnChain.png": "b5d0",
	"./Tech and Security/Aver.png": "c095",
	"./Tech and Security/CipherTrace.png": "0304",
	"./bank-of-america.png": "f2d7",
	"./binance.png": "e8c2",
	"./fortune.png": "3cb7",
	"./idg-capital.png": "9dc1",
	"./paretone-capital.png": "43de",
	"./polychain-capital.png": "36e5",
	"./time.png": "0bee",
	"./wsj.png": "7b0c",
	"./zhen-fund.png": "477b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd50";